import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';
import { CreateUser, UserUpdate, getUserByAddress } from '../../../hooks/User';
import { avatar } from '../../../assets/img';
import { client } from '../../../config/ipfsConfig';
import { Button, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';

const Register = () => {
  useDocumentTitle('Register');
  const [fileUrl, setFileUrl] = useState(null);
  const [fileUrl1, setFileUrl1] = useState(null);
  const [formInput, updateFormInput] = useState([]);
  const [facebook, setFacebook] = useState(null);
  const [twitter, setTwitter] = useState(null);
  const [discord, setDiscord] = useState(null);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [updateUserCheck, setUpdateUserCheck] = useState(false);
  const [media, setMedia] = useState(null);
  const [media1, setMedia1] = useState(null);
  const [usernameError, setUsernameError] = useState('');
  const [username, setUsername] = useState(user ? user.username : ''); // To track the input
  const walletaddres = localStorage.getItem("WalletAddress");
  const Navigate = useNavigate();

  // Function to handle username input change
  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsername(value);
    // Clear error when the user starts typing
    if (value.trim() === '') {
      setUsernameError('Username is required');
    } else {
      setUsernameError('');
    }
  };

  function closeModal() {
    setOpen(false);
  }


  const register = async () => {
    // Check if the username is valid before proceeding
   
  
    if (!username || username.trim() === '') {
      setUsernameError('Username is required');
      toast.error('Username is required!');
      return; // Stop execution if validation fails
    }

    const body = {
      name: updateUserCheck ? user.name : formInput.name,
      username: username.trim(), // Use trimmed and validated username
      bio: updateUserCheck ? user.bio : formInput.bio,
      email: updateUserCheck ? user.email : formInput.email,
      walletAddress: updateUserCheck ? user.walletAddress : walletaddres,
      isProfileNFT: false,
      socials: [
        updateUserCheck ? user.facebook : facebook,
        updateUserCheck ? user.twitter : twitter,
        updateUserCheck ? user.discord : discord,
      ],
    };

    if (updateUserCheck) {
      UserUpdate(body, user._id).then((data) => {
        if (data.status === 200) {
          toast.success('User updated successfully!');
          Navigate('/profile');
        }
      });
    } else {
      CreateUser(body).then((res) => {
        if (res.status === 201) {
          toast.success("User Created Successfully !!!")
          setTimeout(() => {
            setUser(res.data);
            if (walletaddres && fileUrl1) {
              setOpen(true);
            }
          }, 2000);
        }
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  useEffect(() => {
    if (walletaddres)
      // getBalance();
      Getuser();
  }, [walletaddres])

  const Getuser = () => {
    getUserByAddress(walletaddres).then((data) => {
      if (data.status === 200) {
        setUser(data.user)
        if (data.user.walletAddress) {
          setUpdateUserCheck(true);
        }
      }
    })
  }

  async function handleChange(e) {
    const file = e.target.files[0];
    ChangeImg(e.target.files[0])
    try {
      const added = await client.add(file, {
        progress: (prog) => console.log(`received: ${prog}`),
      });
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;
      if (user) {
        user.coverPicture = url;
        const body = {
          coverPicture: url
        }
        UserUpdate(body, user._id).then((data) => {
          if (data.status === 200) {
            toast.success("Cover Picture update Successfully !!!")
            Getuser()
          }
        })
      }
      else {
        setFileUrl(url);
      }
    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  }

  async function handleChange1(e) {
    const file = e.target.files[0];
    ChangeImg1(e.target.files[0])
    try {
      const added = await client.add(file)
      const url = `https://ipfs.infura.io/ipfs/${added.path}`;
      if (user) {
        user.profilePicture = url;
        const body = {
          profilePicture: url
        }
        UserUpdate(body, user._id).then((data) => {
          if (data.status === 200) {
            toast.success("Profile Picture update Successfully !!!");
            Getuser();
          }
        })
      }
      else {
        setFileUrl1(url);
      }

    } catch (error) {
      console.log("Error uploading file: ", error);
    }
  }

  async function handleData(e) {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    })
    updateFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    })
  }

  const ChangeImg = (files) => {
    let reader = new FileReader();
    reader.readAsDataURL(files);
    reader.onload = (readerEvent) => {
      let newfile = readerEvent.target.result;
      setMedia(newfile);
    };
  };

  const ChangeImg1 = (files) => {
    let reader = new FileReader();
    reader.readAsDataURL(files);
    reader.onload = (readerEvent) => {
      let newfile = readerEvent.target.result;
      setMedia1(newfile);
    };
  };

  const Upgrade = () => {
    const body = {
      isProfileNFT: true
    }
    UserUpdate(body, user._id).then((data) => {
      console.log("data", data);
    })
    setOpen(!open);
    toast.success("Profile Photo upgrade as a NFT !!!")
    setTimeout(() => {
      Navigate('/profile');
    }, 2000);
  }

  return (
    <div>
      <ToastContainer position="bottom-right" />
      <div className="edit_profile register createP-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-3" />
            <div className="col-lg-9">
              <div className="right_part space-y-20">
                <h1 className="color_white"> {updateUserCheck ? "Update Your Account" : "Setup Your Account"}</h1>
                <p className="color_white" style={{ color: 'white !important' }}>
                  You can set preferred display name, create your profile URL
                  and manage other personal settings.
                </p>
                <div className="box edit_box w-full space-y-20">
                  <div className="row">
                    <div className="col-lg-6 account-info">
                      <div className="avatars mb-30">
                        <div id="profile-container">
                          <img
                            id="profileImage"
                            src={updateUserCheck ? user.profilePicture : fileUrl1 !== null ? media1 : avatar}
                            alt="Avatar"
                            className="avatar avatar-lg border-0"
                          />
                        </div>
                        <div>
                          <h6 className="mb-1">Profile photo</h6>
                          <p className="mb-1">
                            We recommend an image of at least 400x400. Gifs work
                            too 🙌
                          </p>
                          <div id="boxUpload">
                            <Link to="#" className="btn btn-sm btn-dark">
                              Upload
                            </Link>
                            <input
                              id="imageUpload"
                              type="file"
                              name="profilephoto"
                              placeholder="Photo"
                              required=""
                              capture=""
                              onChange={(e) =>
                                handleChange1(e)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="avatars space-x-20 mb-30">
                        
                        <div id="profile-container">

                          <img
                            id="profileImage"
                            src={updateUserCheck ? user.coverPicture : fileUrl !== null ? media : avatar}
                            alt="Avatar"
                            className="avatar avatar-lg border-0"
                          />
                        </div>
                        <div>
                          <h5 className="mb-1">Cover photo</h5>
                          <p className="mb-1 p3">
                            We recommend an image of at least 400x400. Gifs work
                            too 🙌
                          </p>
                          <div id="boxUpload">
                            <Link to="" className="btn btn-sm btn-grad p3 px-5">
                              Upload{" "}
                            </Link>
                            <input
                              id="imageUpload"
                              type="file"
                              name="coverphoto"
                              placeholder="Photo"
                              required=""
                              capture=""
                              onChange={(e) =>
                                handleChange(e)
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <h3 className="mb-20"> 🍉 Account info </h3>
                      <div className="form-group space-y-10 mb-0">
                        <div className="space-y-20">
                          <div className="space-y-10 input_place">
                            <span className="nameInput p3"> Name</span>
                            <input
                              type="text"
                              name="name"
                              className="form-control"
                              placeholder={updateUserCheck ? (updateUserCheck ? user.name : formInput.name) : "Enter Name"}
                              onChange={(e) => handleData(e)}
                            />
                          </div>

                          <div className="space-y-10 input_place">
                            <span className="nameInput p3">User name</span>
                            <input
                              type="text"
                              className={`form-control ${usernameError ? 'is-invalid' : ''}`} // Add class for invalid input
                              name="username"
                              placeholder={
                                updateUserCheck
                                  ? user.username || 'Enter username'
                                  : 'Enter username'
                              }
                              value={username} // Bind input value to state
                              onChange={handleUsernameChange} // Update on change
                            />
                            {/* Conditionally render error message */}
                            {usernameError && (
                              <div className="invalid-feedback" style={{ color: 'red' }}>
                                {usernameError}
                              </div>
                            )}
                          </div>
                          <div className="space-y-10 input_place">
                            <span className="nameInput p3">Wallet Address</span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Wallet Address"
                              readOnly
                              value={walletaddres}
                            />
                          </div>
                          <div className="space-y-10 input_place">
                            <span className="nameInput d-flex justify-content-between p3">
                              Email
                              <span className="txt_x color_text">
                                Your email for marketplace notifications
                              </span>
                            </span>
                            <div className="confirm">
                              <input
                                type="text"
                                className="form-control"
                                name="email"
                                placeholder={updateUserCheck ? (updateUserCheck ? user.email : formInput.email) : "Enter Email"}
                                onChange={(e) => handleData(e)} />
                              <Link
                                to=""
                                className="confirm-btn btn btn-dark btn-sm p4 px-5"
                              >
                                Confirm
                              </Link>
                            </div>
                          </div>
                          <div className="space-y-10 input_place">
                            <span className="nameInput p3">Bio</span>
                            <textarea
                              className="txtarea"
                              name="bio"
                              placeholder={updateUserCheck ? user.bio : formInput.bio}
                              onChange={(e) => handleData(e)}

                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 social-media">
                      <h3 className="mb-20">👨 Social media ‍</h3>
                      <div className="form-group space-y-10">
                        <div className="space-y-20">
                          <div className="d-flex flex-column">
                            <span className="nameInput mb-10">Facebook</span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="facebook username"
                              onChange={(e) => setFacebook(e.target.value)}
                            />
                            <Link
                              className="facebook-btn btn btn-primary mt-10 btn-sm"
                              to="#">
                              <i className="ri-facebook-circle-fill" />
                              Connect to Facebook
                            </Link>
                          </div>
                          <div className="d-flex flex-column">
                            <span className="nameInput mb-10">Twitter</span>
                            <input
                              type="text"
                              className="form-control"
                              onChange={(e) => setTwitter(e.target.value)}
                              placeholder="twitter username"
                            />
                            <Link
                              className="twitter-btn btn btn-primary mt-10 btn-sm"
                              to="#">
                              <i className="ri-twitter-fill" />
                              Connect to Twitter
                            </Link>
                          </div>
                          <div className="d-flex flex-column">
                            <span className="nameInput mb-10">Discord</span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="discord username"
                              onChange={(e) => setDiscord(e.target.value)}
                            />
                            <Link
                              className="discord-btn btn btn-primary mt-10 btn-sm"
                              to="#">
                              <i className="ri-discord-fill" />
                              Connect to Discord
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="hr" />
                  <p className="color_black">
                    Please take a few minutes to read and understand Stacks
                    Terms of Service. To continue, you’ll need to accept the
                    terms of services by checking the boxes.
                  </p>
                  <button onClick={register} className="btn btn-grad p3"
                    disabled={!username || username.trim() === '' ? true : false}
                  >
                    {updateUserCheck ? "Update" : "Register"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={open}
        size="lg"
        onHide={closeModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Upgrade Profile
          </Modal.Title>

        </Modal.Header>
        <Modal.Body>
          <h4>  Please upgrade a profile Photo as
            NFTs</h4>
          <p>
            We can upgrade our profile picture as a first NFTs for our trade and understanding about NFTs and marketplace.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => Navigate("/profile")}>Cancal</Button>
          <Button onClick={() => Upgrade()}>Upgrade Profile Photo as NFT</Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position='bottom-right' />
    </div>
  );
};

export default Register;
